import React, { useEffect, useState } from 'react';
import API from '../api';
import LeafletMap from './LeafletMap';

export default function MapView() {
  const [events, setEvents] = useState([]);
  const [buses, setBuses] = useState([]);
  const [school, setSchool] = useState(null);
  const [geofenceForm, setGeofenceForm] = useState({ geo_lat: '', geo_lng: '', geo_radius: 300 });
  const [geoMsg, setGeoMsg] = useState('');
  const [geoLoading, setGeoLoading] = useState(false);
  const [clickedPos, setClickedPos] = useState(null);
  const today = new Date().toISOString().split('T')[0];

  const load = () => {
    API.get(`/events/school/1?date_filter=${today}`).then(r => setEvents(r.data)).catch(() => {});
    API.get('/bus/school/1').then(r => setBuses(r.data)).catch(() => {});
    API.get('/schools/1').then(r => {
      setSchool(r.data);
      if (r.data.geo_lat) setGeofenceForm({ geo_lat: r.data.geo_lat, geo_lng: r.data.geo_lng, geo_radius: r.data.geo_radius });
    }).catch(() => {});
  };

  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, []);

  const saveGeofence = async () => {
    setGeoLoading(true); setGeoMsg('');
    const fd = new FormData();
    fd.append('geo_lat', geofenceForm.geo_lat);
    fd.append('geo_lng', geofenceForm.geo_lng);
    fd.append('geo_radius', geofenceForm.geo_radius);
    try {
      await API.put('/schools/1/geofence', fd);
      setGeoMsg('Geofence enregistré !');
      load();
    } catch { setGeoMsg('Erreur lors de la sauvegarde.'); }
    setGeoLoading(false);
  };

  const handleMapClick = (lat, lng) => {
    setClickedPos({ lat, lng });
    setGeofenceForm(f => ({ ...f, geo_lat: lat.toFixed(6), geo_lng: lng.toFixed(6) }));
  };

  const eventMarkers = events
    .filter(e => e.latitude && e.longitude)
    .map(e => ({
      lat: e.latitude, lng: e.longitude,
      color: e.inside_zone === false ? '#d32f2f' : e.event_type === 'entry' ? '#34a853' : '#f57c00',
      popup: `<b>${e.student?.name || e.teacher?.name || 'Inconnu'}</b><br>
              ${e.event_type === 'entry' ? 'Entrée' : 'Sortie'} — ${new Date(e.timestamp).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}<br>
              ${e.inside_zone === false ? '<span style="color:#d32f2f;font-weight:600">Hors zone</span>' : ''}`,
    }));

  const busMarkers = buses
    .filter(b => b.latitude)
    .map(b => ({
      lat: b.latitude, lng: b.longitude, color: '#e65100',
      popup: `<b>${b.name}</b><br>Chauffeur : ${b.driver_name}<br>${b.speed ? b.speed + ' km/h' : 'Arrêté'}<br>MAJ : ${b.last_updated ? new Date(b.last_updated).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : 'N/A'}`,
    }));

  if (clickedPos) {
    eventMarkers.push({ lat: clickedPos.lat, lng: clickedPos.lng, color: '#9c27b0', popup: `Clic : ${clickedPos.lat.toFixed(5)}, ${clickedPos.lng.toFixed(5)}` });
  }

  const allMarkers = [...eventMarkers, ...busMarkers];
  const circle = school?.geo_lat ? { lat: school.geo_lat, lng: school.geo_lng, radius: school.geo_radius, color: '#1a73e8' } : null;
  const center = school?.geo_lat ? [school.geo_lat, school.geo_lng] : [5.36, -4.01];

  const outsideEvents = events.filter(e => e.inside_zone === false);

  return (
    <div>
      <h1 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '4px' }}>Carte & GPS</h1>
      <p style={{ color: '#666', marginBottom: '20px', fontSize: '13px' }}>Événements du jour + bus en temps réel</p>

      {/* Alertes hors zone */}
      {outsideEvents.length > 0 && (
        <div style={{ background: '#ffebee', border: '1px solid #ef9a9a', borderRadius: '10px', padding: '12px 16px', marginBottom: '20px' }}>
          <div style={{ fontWeight: '700', color: '#c62828', marginBottom: '6px' }}>Alertes hors zone ({outsideEvents.length})</div>
          {outsideEvents.map(e => (
            <div key={e.id} style={{ fontSize: '13px', color: '#555', marginBottom: '4px' }}>
              {e.student?.name || e.teacher?.name || 'Inconnu'} — {new Date(e.timestamp).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
            </div>
          ))}
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '24px' }}>
        {/* Carte principale */}
        <div>
          <div style={{ background: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginBottom: '12px' }}>
            <div style={{ padding: '12px 16px', borderBottom: '1px solid #f0f0f0', fontSize: '13px', color: '#666' }}>
              Cliquez sur la carte pour définir le centre du geofence
            </div>
            <LeafletMap center={center} zoom={15} markers={allMarkers} circle={circle} style={{ height: '420px' }} onMapClick={handleMapClick} />
          </div>
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            {[
              { color: '#34a853', label: 'Entrée (dans zone)' },
              { color: '#f57c00', label: 'Sortie' },
              { color: '#d32f2f', label: 'Hors zone' },
              { color: '#e65100', label: 'Bus' },
            ].map(l => (
              <div key={l.label} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: '#666' }}>
                <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: l.color }} />
                {l.label}
              </div>
            ))}
          </div>
        </div>

        {/* Panneau droit */}
        <div>
          {/* Config geofence */}
          <div style={{ background: '#fff', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginBottom: '16px' }}>
            <h2 style={{ fontSize: '15px', fontWeight: '700', marginBottom: '14px' }}>Geofence école</h2>
            <p style={{ fontSize: '12px', color: '#888', marginBottom: '12px' }}>Cliquez sur la carte pour placer le centre, ou saisissez manuellement.</p>

            {[['Latitude', 'geo_lat'], ['Longitude', 'geo_lng']].map(([label, key]) => (
              <div key={key} style={{ marginBottom: '10px' }}>
                <label style={{ fontSize: '12px', color: '#666', display: 'block', marginBottom: '3px' }}>{label}</label>
                <input type="number" step="0.000001" value={geofenceForm[key]}
                  onChange={e => setGeofenceForm(f => ({ ...f, [key]: e.target.value }))}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '13px', boxSizing: 'border-box' }} />
              </div>
            ))}
            <div style={{ marginBottom: '12px' }}>
              <label style={{ fontSize: '12px', color: '#666', display: 'block', marginBottom: '3px' }}>Rayon (mètres)</label>
              <input type="number" value={geofenceForm.geo_radius}
                onChange={e => setGeofenceForm(f => ({ ...f, geo_radius: parseInt(e.target.value) }))}
                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '13px', boxSizing: 'border-box' }} />
            </div>
            {geoMsg && <div style={{ padding: '8px', borderRadius: '8px', marginBottom: '10px', fontSize: '12px', background: geoMsg.includes('!') ? '#e8f5e9' : '#ffebee', color: geoMsg.includes('!') ? '#2e7d32' : '#c62828' }}>{geoMsg}</div>}
            <button onClick={saveGeofence} disabled={geoLoading} style={{ width: '100%', padding: '10px', background: '#1a73e8', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>
              {geoLoading ? 'Sauvegarde...' : 'Enregistrer la zone'}
            </button>
          </div>

          {/* Bus en service */}
          <div style={{ background: '#fff', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
            <h2 style={{ fontSize: '15px', fontWeight: '700', marginBottom: '12px' }}>Bus ({buses.length})</h2>
            {buses.length === 0
              ? <p style={{ color: '#999', fontSize: '13px' }}>Aucun bus enregistré</p>
              : buses.map(b => (
                <div key={b.id} style={{ borderBottom: '1px solid #f0f0f0', paddingBottom: '10px', marginBottom: '10px' }}>
                  <div style={{ fontWeight: '600', fontSize: '13px' }}>{b.name}</div>
                  <div style={{ fontSize: '12px', color: '#666' }}>{b.driver_name} — {b.plate || 'N/A'}</div>
                  <div style={{ fontSize: '12px', color: b.latitude ? '#34a853' : '#999', marginTop: '2px' }}>
                    {b.latitude ? `En ligne — ${b.speed ? b.speed + ' km/h' : 'Arrêté'}` : 'Hors ligne'}
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}
